import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SocketService } from '../../services/socket.service';



@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss']
})


export class BannerComponent implements OnInit {
    public activeLogo: string = 'lg';
    private logos: Array<string> = ['digitopia'];
    private rankingChangeSubscriber: Subscription
    public showZone: boolean = true;
    public showLocation = 'top';
    public disabled: boolean;
    private interval;
    private intervalToggleVisibility;
    private intervalToggleLocation;
    //------------------------------------------------------------------- CONSTRUCTOR
    constructor(
        private socketService: SocketService,
    ) { }

    //------------------------------------------------------------------- INIT
    ngOnInit() {
        let teller: number = 0;
        setInterval(() => {
            this.activeLogo = this.logos[teller];
            if (teller == this.logos.length - 1) {
                teller = 0;

            } else {
                teller++;
            }

        }, 5000);
        this.rankingChangeSubscriber = this.socketService.onRankingUpdate().subscribe((data) => {
            console.log(data)

            if (this.interval) clearInterval(this.interval)
            this.disabled = true;

            this.interval = setTimeout(() => {
                this.disabled = false;
                /*
                if (!this.intervalToggleVisibility) {
                    this.intervalToggleVisibility = setInterval(() => {
                        this.toggleVisibility();
                    }, 30000);
                }*/

                if (!this.intervalToggleLocation) {
                    this.intervalToggleLocation = setInterval(() => {
                        this.toggleLocation();
                    }, 60000);
                }
            }, 10000);



        });


    }

    toggleVisibility() {
        console.log('toggleVisibility()');
        if (this.showZone) {
            this.showZone = false;
        } else {
            this.showZone = true;
        }
    }
    toggleLocation() {
        console.log('toggleLocation()');
        if (this.showLocation == 'top') {
            this.showLocation = 'bottom';
        } else {
            this.showLocation = 'top';
        }
    }

    //------------------------------------------------------------------- DESTROY
    ngOnDestroy() {
        if (this.rankingChangeSubscriber) this.rankingChangeSubscriber.unsubscribe();
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/banner/banner.component.ts